import {styled} from '@mui/material/styles';
import {getAlertColor} from '../../helpers/getColor';
import {BaseFieldProps} from '../types/BaseFieldProps';
import {FileInputComponentProps} from '../types/FileInputComponentProps';
import {excludeComponentProps} from '../../utils/excludeComponentProps';

export interface StyledFileInputProps extends FileInputComponentProps, BaseFieldProps {
}

export const StyledFileInput = styled('div', {
    ...excludeComponentProps('error', 'disabled', 'noClick')
})<StyledFileInputProps>(({
    theme: {tokens},
    error,
    disabled
}) => {
    return {
        position: 'relative',
        minHeight: '15rem',
        flexGrow: 1,
        overflow: 'hidden',

        border: 'none',
        outline: `dashed 0.125rem ${tokens.FuelColorBorderBase}`,
        outlineOffset: '-2px',
        borderRadius: tokens.FuelBorderRadiusMd,
        padding: '3.5rem 4.375rem',
        backgroundColor: tokens.FuelColorWhite,

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        ...disabled && {
            cursor: 'no-drop',
            outlineColor: tokens.FuelColorGray200
        },

        ...error && {
            outlineStyle: 'solid',
            outlineColor: getAlertColor(tokens, 'error', 'icon')
        },

        '& .FileInput-content': {
            zIndex: 0,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',

            '& .FileInput-information': {
                width: '100%',
                marginBottom: '1rem',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',

                maxHeight: '20rem',
                overflowY: 'auto',

                '& .FileInput-icon': {
                    height: '2.25rem',
                    width: '2.25rem',
                    color: tokens.FuelColorGray800,

                    ...disabled && {
                        opacity: 0.5
                    }
                }
            }
        },

        '& + .MuiFormHelperText-root': {
            marginTop: tokens.FuelSpacing1
        }
    };
});
